import { Box, Typography } from '@mui/material';
import { Outlet } from 'react-router';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { NexusRole } from '@/shared/constants/roles';

interface ProtectedRouteProps {
  requiredRole?: NexusRole;
  fallbackPath?: string;
}

export function ProtectedRoute({ requiredRole, fallbackPath = '/' }: ProtectedRouteProps) {
  const { loading, hasRole } = useAuth();

  if (loading) {
    return null;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    if (fallbackPath) {
      return <Navigate to={fallbackPath} replace />;
    }
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        <Typography variant='h6' color='error'>
          Access Denied: You do not have permission to view this page.
        </Typography>
      </Box>
    );
  }

  return <Outlet />;
}
